module.exports = __webpack_public_path__ + "static/media/vc.0d52b111.svg";